import { render } from "./purchase-order.vue?vue&type=template&id=13669c1d&scoped=true"
import script from "./purchase-order.vue?vue&type=script&lang=js"
export * from "./purchase-order.vue?vue&type=script&lang=js"

import "./purchase-order.vue?vue&type=style&index=0&id=13669c1d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13669c1d"]])

export default __exports__